import React from "react";
import { Modal } from "react-bootstrap";
import { DayPicker } from "react-day-picker";
import {
    getWeekDayName,
    toDayAndMonthString,
} from "../../common/dateUtils";
import ApplicationPeriod from "../../types/ApplicationPeriod";

type DateFilterModalProps = {
    show: boolean;
    onHide: () => void;
    selectedDates: Date[];
    onSelectedDatesChange: (newDates: Date[] | undefined) => void,
    applicationPeriod: ApplicationPeriod;
};

function DateFilterModal({
    show,
    onHide,
    selectedDates,
    onSelectedDatesChange,
    applicationPeriod,
}: DateFilterModalProps) {
    const selectedDatesString = selectedDates.map((d) => toDayAndMonthString(d)).join(", ");

    const defaultMonth = selectedDates.length > 0 ? selectedDates[0] : applicationPeriod.occasionsFrom;

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <input type="text" className="form-control w-75 m-auto" disabled value={selectedDatesString} />
                <DayPicker
                    mode="multiple"
                    className="d-flex justify-content-center"
                    weekStartsOn={1}
                    defaultMonth={defaultMonth}
                    selected={selectedDates}
                    onSelect={onSelectedDatesChange}
                    formatters={{ formatWeekdayName: getWeekDayName }}
                /> 
            </Modal.Body>
        </Modal>
    );
}

export default DateFilterModal;
